export default {
  deposit: {
    crypto: 'Kripto',
    fiatOrCash: 'Fiat/Tunai',
    depositCurrency: 'Mata Uang Setoran',
    chooseNetwork: 'Pilih Jaringan',
    depositAddress: 'Alamat setoran',
    copy: 'Salin',
    copied: 'Tersalin!',
    close: 'Tutup',
    more: 'Lainnya',
    select: 'Pilih',
    channel: 'Saluran',
    loading: 'Memuat...',
    noCurrency: 'Tidak ada mata uang tersedia',
    bonusTip: 'Nikmati bonus setoran pada isi ulang pertama Anda, dengan kredit tambahan hingga 200%.',
    minDeposit: 'Setoran Minimum',
    sendOnly: 'Kirim hanya {currency} ke alamat setoran ini. Koin akan disetor otomatis setelah {confirmations} konfirmasi jaringan.',
    depositAmount: 'Jumlah Setoran',
    enterAmount: 'Masukkan jumlah',
    confirmDeposit: 'Konfirmasi Setoran',
    depositTitle: 'Setoran',
    selectChannel: 'Pilih Saluran',
    subtitle: 'Cepat, aman, dan praktis',
    secureEncrypted: 'Aman dan Terenkripsi',
    terms: 'Dengan melanjutkan, Anda menyetujui Syarat & Ketentuan kami',
    totalDepositAmount: 'Total jumlah setoran',
    fee: 'Biaya',
    arrivalAmount: 'Jumlah yang dikreditkan',
    payMethod: 'Metode Pembayaran',
    cpf: 'CPF',
    enterCpf: 'Silakan masukkan CPF Anda',
    depositSuccess: 'Setoran berhasil!',
    depositFailed: 'Setoran gagal, silakan coba lagi.',
    mockArrive: 'Simulasi Masuk (Uji)',
    activity: {
      firstChargeTitle: 'Acara Pendaftaran Isi Ulang Pertama',
      firstChargeSubtitle: 'Daftarkan setoran pertama Anda untuk menerima hadiah eksklusif',
      dailyThreeTitle: 'Tiga Isi Ulang Harian',
      dailyThreeSubtitle: 'Selesaikan 3 setoran per hari untuk klaim bonus tambahan',
      dailyPreviewLabel: 'Hadiah Isi Ulang Pertama',
      upTo: 'Hingga {amount} {unit}',
      safeTitle: 'Dana Anda aman bersama kami',
      safeDesc: 'Kami menggunakan keamanan terdepan di industri untuk melindungi transaksi dan informasi pribadi Anda.',
      dailyFirst: 'Isi Ulang Harian ke-1',
      dailySecond: 'Isi Ulang Harian ke-2',
      dailyThird: 'Isi Ulang Harian ke-3',
      lossReward: 'Pengembalian Kerugian',
      lossRewardSubtitle: 'Dapatkan uang kembali atas kerugian Anda',
      rebateUpTo: 'Rebat hingga {ratio}%',
      notEligible: 'Anda tidak lagi memenuhi syarat untuk aktivitas ini',
      lossNeedSelect: 'Pilih aktivitas ini saat menyetor untuk mengikuti cashback',
      claimed: 'Diklaim',
      claim: 'Klaim',
      noTier: 'Tidak ada tingkatan',
      claimWillOpen: 'Klaim dibuka pukul {time}',
      claimTimeNotReached: 'Klaim belum dibuka. Silakan kembali setelah {time}.',
      bonus: 'Bonus',
      rebate: 'Rebat',
      depositGE: 'Setoran ≥ {amount}',
      lossGE: 'Kerugian ≥ {amount}',
      claimSuccess: 'Berhasil diklaim',
      claimFailed: 'Gagal diklaim',
      alreadyClaimed: 'Anda sudah mengklaim tingkatan ini. Jangan klik lagi.',
      lossAlreadyClaimed: 'Anda sudah mengklaim pengembalian kerugian tingkatan ini. Jangan klik lagi.',
      requireLogin: 'Silakan login sebelum mengklaim.',
      depositNotEnough: 'Jumlah setoran Anda belum memenuhi syarat. Terus berusaha!',
      lossNotEnough: 'Jumlah kerugian kemarin belum memenuhi syarat.',
      onlyHighest: 'Hadiah aktivitas ini hanya dapat diklaim pada tingkat tertinggi.',
    },
  },
};
